import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { CDN_DOMAIN } from "../constants";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type Quality = 'auto' | 'best' | 'good' | 'eco' | 'low';

/**
 * Genera automaticamente un URL Thumbnail (JPG) da un URL Video.
 * 
 * Per il nuovo CDN, se non abbiamo thumbnail, ritorniamo una stringa vuota o un placeholder trasparente
 * per evitare errori 404, dato che S3 non genera thumbnail al volo.
 */
export function generateVideoThumbnail(videoUrl: string | undefined, width: number = 600, quality: Quality = 'eco'): string {
  if (!videoUrl) return "https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=60&w=400&auto=format&fit=crop"; // Fallback
  
  // Se è il nuovo CDN, proviamo a generare l'URL della thumbnail (AVIF)
  // Assumiamo che per ogni video.mp4 esista un video.avif nella stessa cartella S3
  if (videoUrl.includes(CDN_DOMAIN) || videoUrl.includes('cloudfront.net')) {
      return videoUrl.replace(/\.(mp4|mov|webm)$/i, '.avif');
  }
  
  return videoUrl;
}